module.exports = __webpack_public_path__ + "static/media/eBill.9777e6b3.jpg";